module.exports = __webpack_public_path__ + "78438b69244ba44fa7b4a61825c91d1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/microsoft.png
// module id = 2040
// module chunks = 0